import React from 'react';
import { createRoot } from 'react-dom/client';
import type { Root } from 'react-dom/client';
import { retry } from '../../../shared/common/retry';

const LOGO_SVG_BASE64 =
  'data:image/svg+xml;base64,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';

const containerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  background: '#111',
  color: '#fff',
  fontFamily: "'Salesforce Sans', Arial, sans-serif"
};

const loadingContainerStyle: React.CSSProperties = {
  ...containerStyle,
  background: '#1a1a1a'
};

export const ErrorScreen: React.FC<{ title: string; message: string }> = ({ title, message }) => (
  <div style={containerStyle}>
    <img src={LOGO_SVG_BASE64} alt="RaiderIO Logo" style={{ width: '200px', height: 'auto', marginBottom: '2rem' }} />
    <div style={{ fontSize: '1.2rem', marginBottom: '1rem', color: '#ff6b6b' }}>
      <i className="fa fa-exclamation-triangle" style={{ marginRight: '0.5rem' }}></i>
      {title}
    </div>
    <div style={{ fontSize: '0.9rem', color: '#aaa', marginBottom: '2rem', textAlign: 'center', maxWidth: '500px' }}>
      {message}
    </div>
    <button className="slds-button slds-button--brand" onClick={() => window.location.reload()}>
      Reload
    </button>
  </div>
);

export const LoadingScreen: React.FC = () => (
  <div style={loadingContainerStyle}>
    <img src={LOGO_SVG_BASE64} alt="RaiderIO Logo" style={{ width: '200px', height: 'auto', marginBottom: '2rem' }} />
    <div style={{ fontSize: '1.2rem', marginBottom: '1rem' }}>
      <i className="fa fa-spinner fa-spin" style={{ marginRight: '0.5rem' }}></i>
      Loading...
    </div>
  </div>
);

let currentScreenRoot: Root | null = null;
let currentRootElement: HTMLElement | null = null;

export function showErrorScreen(title: string, message: string) {
  const rootElement = document.getElementById('application');
  if (!rootElement) {
    return;
  }

  // If we have an existing root on a different element, unmount it
  if (currentScreenRoot && currentRootElement !== rootElement) {
    currentScreenRoot.unmount();
    currentScreenRoot = null;
    currentRootElement = null;
  }

  // Create root if needed, otherwise reuse existing
  if (!currentScreenRoot) {
    rootElement.innerHTML = '';
    currentScreenRoot = createRoot(rootElement);
    currentRootElement = rootElement;
  }

  currentScreenRoot.render(<ErrorScreen title={title} message={message} />);
}

export function showLoadingScreen() {
  const rootElement = document.getElementById('application');
  if (!rootElement) {
    return;
  }

  // If we have an existing root on a different element, unmount it
  if (currentScreenRoot && currentRootElement !== rootElement) {
    currentScreenRoot.unmount();
    currentScreenRoot = null;
    currentRootElement = null;
  }

  // Create root if needed, otherwise reuse existing
  if (!currentScreenRoot) {
    rootElement.innerHTML = '';
    currentScreenRoot = createRoot(rootElement);
    currentRootElement = rootElement;
  }

  currentScreenRoot.render(<LoadingScreen />);
}

export function clearScreens() {
  if (currentScreenRoot) {
    currentScreenRoot.unmount();
    currentScreenRoot = null;
    currentRootElement = null;
  }
}

export interface FetchWithRetryOptions {
  maxRetries?: number;
  retryDelay?: number;
  timeoutMs?: number;
}

export async function fetchWithRetry(
  url: string,
  resourceName: string,
  options: FetchWithRetryOptions = {}
): Promise<any> {
  const { maxRetries = 3, retryDelay = 1000, timeoutMs = 10000 } = options;
  let lastError: Error | null = null;

  try {
    return await retry(
      async () => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

        try {
          const response = await fetch(url, { signal: controller.signal });
          clearTimeout(timeoutId);

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          return await response.json();
        } catch (fetchErr: any) {
          clearTimeout(timeoutId);
          if (fetchErr.name === 'AbortError') {
            throw new Error(`Request timeout after ${timeoutMs}ms`);
          }
          throw fetchErr;
        }
      },
      {
        retries: maxRetries,
        initialDelay: retryDelay,
        delayFunction: (attemptNumber, initialDelay) => initialDelay * attemptNumber,
        onRetry: (error, attemptNumber) => {
          lastError = error instanceof Error ? error : new Error(String(error));
          console.warn(`Failed to fetch ${resourceName} (attempt ${attemptNumber}/${maxRetries}):`, lastError.message);
        }
      }
    );
  } catch (error: unknown) {
    const caughtError = error instanceof Error ? error : new Error(String(error));
    if (!lastError) {
      lastError = caughtError;
    }
    throw new Error(`FATAL: Failed to fetch ${resourceName} after ${maxRetries} attempts: ${lastError.message}`);
  }
}

export interface InitialData {
  siteConfig: {
    siteMetaUrl?: string;
    localeConfigUrl?: string;
    [key: string]: any;
  };
  siteMeta?: {
    raids?: any[];
    site?: string;
    allSites?: any;
    [key: string]: any;
  };
  localeConfig?: {
    [key: string]: any;
  };
  [key: string]: any;
}

export interface InitializeAppDataOptions {
  initialData: InitialData;
  onLoadingScreenShown?: () => void;
  loadingScreenDelay?: number;
}

export async function initializeAppData(options: InitializeAppDataOptions): Promise<void> {
  const { initialData, onLoadingScreenShown, loadingScreenDelay = 500 } = options;

  if (!initialData.siteConfig.siteMetaUrl || !initialData.siteConfig.localeConfigUrl) {
    throw new Error('Missing siteMetaUrl or localeConfigUrl');
  }

  let isLoadingScreenShown = false;
  let loadingScreenTimeout: ReturnType<typeof setTimeout> | null = null;

  const showLoadingScreenDelayed = () => {
    loadingScreenTimeout = setTimeout(() => {
      showLoadingScreen();
      isLoadingScreenShown = true;
      if (onLoadingScreenShown) {
        onLoadingScreenShown();
      }
    }, loadingScreenDelay);
  };

  showLoadingScreenDelayed();

  const fetchPromises: Promise<any>[] = [];

  // Only fetch siteMeta if it's not already in initialData (e.g., from SSR)
  // Check if siteMeta exists and has required properties (raids array) to determine if it's populated
  const needsSiteMeta =
    initialData.siteConfig.siteMetaUrl &&
    (!initialData.siteMeta || !initialData.siteMeta.raids || initialData.siteMeta.raids.length === 0);

  if (needsSiteMeta) {
    fetchPromises.push(
      fetchWithRetry(initialData.siteConfig.siteMetaUrl, 'siteMeta')
        .then((siteMeta) => {
          initialData.siteMeta = siteMeta;
        })
        .catch((err) => {
          console.error('Failed to fetch siteMeta:', err);
          throw err;
        })
    );
  }

  // Only fetch localeConfig if it's not already in initialData (e.g., from SSR)
  // Check if localeConfig exists and is populated (not empty object)
  const needsLocaleConfig =
    initialData.siteConfig.localeConfigUrl &&
    (!initialData.localeConfig || Object.keys(initialData.localeConfig).length === 0);

  if (needsLocaleConfig) {
    fetchPromises.push(
      fetchWithRetry(initialData.siteConfig.localeConfigUrl, 'localeConfig')
        .then((localeConfig) => {
          initialData.localeConfig = localeConfig;
        })
        .catch((err) => {
          console.error('Failed to fetch localeConfig:', err);
          throw err;
        })
    );
  }

  try {
    // Wait for all fetches to complete before initializing store
    await Promise.all(fetchPromises);

    // Clear the loading screen timeout if it hasn't fired yet
    if (loadingScreenTimeout) {
      clearTimeout(loadingScreenTimeout);
      loadingScreenTimeout = null;
    }

    // Clear loading screen if it was shown, preserving SSR content if present
    if (isLoadingScreenShown) {
      clearScreens();
    }
  } catch (err: any) {
    // Clear the loading screen timeout if it hasn't fired yet
    if (loadingScreenTimeout) {
      clearTimeout(loadingScreenTimeout);
      loadingScreenTimeout = null;
    }

    // Show error screen
    showErrorScreen(
      'Failed to load required resources',
      err.message || 'An error occurred while loading the application.'
    );
    throw err;
  }
}

